<template>
  <div class="container" v-show="!files.length">
    <div v-show="$refs.upload && $refs.upload.dropActive" class="drop-active">
      <h3>Отпустите файл для загрузки</h3>
    </div>
    <div class="title">
      <h4>
        Переместите файл сюда<br>или
      </h4>
      <h4 class="error">
        {{errorMessage}}
      </h4>
      <file-upload
          hidden
          extensions="oga,mp3,wav,mp4"
          name="file"
          class="btn btn-primary"
          accept="oga"
          :drop="true"
          v-model="files"
          @input-filter="inputFilter"
          ref="upload">
        Нажмите сюда
      </file-upload>
    </div>
  </div>
</template>

<script>
import FileUpload from 'vue-upload-component'

export default {
  name: 'FileUploader',
  data: () => ({
    files: [],
    errorMessage: ''
  }),
  methods: {
    inputFilter(newFile, oldFile, prevent) {
      if (!/\.(oga|mp3|wav|mp4)$/i.test(newFile.name)) {
        this.errorMessage = 'Неподдерживаемый формат файла'
        return prevent()
      } else {
        this.errorMessage = ''

        this.$emit('onUploaded', URL.createObjectURL(newFile.file))
      }
    }
  },
  components: { FileUpload }
}
</script>

<style scoped>
  .container {
    height: 100%;
  }
  .title {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
  }
  .error {
    color: red;
  }
  .drop-active {
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    position: fixed;
    z-index: 9999;
    opacity: .6;
    text-align: center;
    background: #000;
  }
  .drop-active h3 {
    margin: -.5em 0 0;
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    font-size: 40px;
    color: #fff;
    padding: 0;
  }

</style>
